import React, { useEffect, useState } from 'react';

export default function CategoriasModal({
  abierto,
  categorias,
  cargando,
  guardando,
  error,
  onClose,
  onCrear,
  onEditar,
  onEliminar,
}) {
  const [nombre, setNombre] = useState('');
  const [destino, setDestino] = useState('COCINA');
  const [editandoId, setEditandoId] = useState(null);
  const [editandoNombre, setEditandoNombre] = useState('');
  const [
    editandoDestino,
    setEditandoDestino,
  ] = useState('COCINA');

  useEffect(() => {
    if (!abierto) {
      setNombre('');
      setDestino('COCINA');
      setEditandoId(null);
      setEditandoNombre('');
      setEditandoDestino('COCINA');
    }
  }, [abierto]);

  if (!abierto) return null;

  const crear = async (event) => {
    event.preventDefault();

    const limpio = nombre.trim();
    if (!limpio) return;

    const resultado = await onCrear(
      limpio,
      destino
    );

    if (resultado?.ok) {
      setNombre('');
    }
  };

  const guardarEdicion = async (id) => {
    const limpio = editandoNombre.trim();
    if (!limpio) return;

    const resultado = await onEditar(
      id,
      limpio,
      editandoDestino
    );

    if (resultado?.ok) {
      setEditandoId(null);
      setEditandoNombre('');
    }
  };

  const eliminar = async (categoria) => {
    const confirmado = window.confirm(
      `¿Eliminar la categoría "${categoria.nombre}"?\n\n` +
        'Los productos asociados quedarán sin categoría.'
    );

    if (!confirmado) return;

    await onEliminar(categoria.id);
  };

  return (
    <div className="fixed inset-0 z-[120] grid place-items-center bg-black/70 p-4 backdrop-blur-sm">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl border border-blanco-puro/20 bg-gradient-to-br from-azul-oscuro to-azul-lago text-blanco-puro shadow-2xl">
        <div className="flex items-start justify-between border-b border-blanco-puro/15 px-6 py-5">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-amarillo-dorado">
              Driza Camp · Cantina
            </div>

            <h2 className="mt-1 text-2xl font-bold">
              Categorías
            </h2>

            <p className="mt-1 text-xs text-blanco-puro/60">
              Organizá los productos para encontrarlos más rápido.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={guardando}
            className="rounded-lg border border-blanco-puro/20 px-3 py-1.5 text-sm hover:bg-blanco-puro/10 disabled:opacity-50"
          >
            Cerrar
          </button>
        </div>

        <div className="p-6">
          <form
            onSubmit={crear}
            className="grid gap-2 sm:grid-cols-[1fr_180px_auto]"
          >
            <input
              autoFocus
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Nueva categoría"
              disabled={guardando}
              className="h-11 min-w-0 flex-1 rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-3 text-blanco-puro placeholder:text-blanco-puro/40 outline-none focus:border-amarillo-dorado focus:ring-2 focus:ring-amarillo-dorado/40"
            />

            <select
              value={destino}
              onChange={(e) =>
                setDestino(e.target.value)
              }
              disabled={guardando}
              className="h-11 rounded-xl border border-blanco-puro/20 bg-azul-oscuro/70 px-3 text-sm text-blanco-puro outline-none focus:border-amarillo-dorado"
            >
              <option value="COCINA">
                Cocina
              </option>
              <option value="ENTREGA_DIRECTA">
                Entrega directa
              </option>
            </select>

            <button
              type="submit"
              disabled={guardando || !nombre.trim()}
              className="rounded-xl bg-amarillo-dorado px-4 text-sm font-bold text-azul-oscuro transition hover:bg-amber-400 disabled:opacity-50"
            >
              Agregar
            </button>
          </form>

          {error && (
            <div className="mt-4 rounded-xl border border-red-300/30 bg-red-500/20 px-3 py-2 text-sm text-red-100">
              {error}
            </div>
          )}

          <div className="mt-5 max-h-[360px] space-y-2 overflow-y-auto">
            {cargando ? (
              <div className="py-8 text-center text-sm text-blanco-puro/60">
                Cargando categorías...
              </div>
            ) : categorias.length === 0 ? (
              <div className="rounded-xl border border-dashed border-blanco-puro/20 p-6 text-center">
                <div className="font-semibold text-amarillo-dorado">
                  Todavía no hay categorías
                </div>

                <div className="mt-1 text-xs text-blanco-puro/55">
                  Creá la primera desde el campo superior.
                </div>
              </div>
            ) : (
              categorias.map((categoria) => (
                <div
                  key={categoria.id}
                  className="flex items-center gap-2 rounded-xl border border-blanco-puro/15 bg-blanco-puro/5 p-3"
                >
                  {editandoId === categoria.id ? (
                    <>
                      <input
                        autoFocus
                        value={editandoNombre}
                        onChange={(e) =>
                          setEditandoNombre(e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Escape') {
                            setEditandoId(null);
                            setEditandoNombre('');
                          }
                        }}
                        className="h-9 min-w-0 flex-1 rounded-lg border border-amarillo-dorado/60 bg-azul-oscuro/70 px-3 text-sm outline-none"
                      />

                      <select
                        value={editandoDestino}
                        onChange={(e) =>
                          setEditandoDestino(
                            e.target.value
                          )
                        }
                        disabled={guardando}
                        className="h-9 rounded-lg border border-blanco-puro/20 bg-azul-oscuro/70 px-2 text-xs outline-none"
                      >
                        <option value="COCINA">
                          Cocina
                        </option>
                        <option value="ENTREGA_DIRECTA">
                          Entrega directa
                        </option>
                      </select>

                      <button
                        type="button"
                        disabled={guardando}
                        onClick={() =>
                          guardarEdicion(categoria.id)
                        }
                        className="rounded-lg bg-verde-esmeralda px-3 py-2 text-xs font-bold text-azul-oscuro disabled:opacity-50"
                      >
                        Guardar
                      </button>

                      <button
                        type="button"
                        disabled={guardando}
                        onClick={() => {
                          setEditandoId(null);
                          setEditandoNombre('');
                        }}
                        className="rounded-lg border border-blanco-puro/20 px-3 py-2 text-xs"
                      >
                        Cancelar
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="min-w-0 flex-1">
                        <div className="truncate font-semibold">
                          {categoria.nombre}
                        </div>
                        <div className="mt-0.5 text-[11px] text-blanco-puro/50">
                          {categoria.destino_restaurante ===
                          'ENTREGA_DIRECTA'
                            ? 'Entrega directa'
                            : 'Cocina'}
                        </div>
                      </div>

                      <button
                        type="button"
                        disabled={guardando}
                        onClick={() => {
                          setEditandoId(categoria.id);
                          setEditandoNombre(categoria.nombre);
                          setEditandoDestino(
                            categoria.destino_restaurante ||
                              'COCINA'
                          );
                        }}
                        className="rounded-lg border border-blanco-puro/25 px-3 py-2 text-xs font-semibold transition hover:border-amarillo-dorado hover:text-amarillo-dorado disabled:opacity-50"
                      >
                        Editar
                      </button>

                      <button
                        type="button"
                        disabled={guardando}
                        onClick={() => eliminar(categoria)}
                        className="rounded-lg border border-red-300/30 px-3 py-2 text-xs font-semibold text-red-100 transition hover:bg-red-500/20 disabled:opacity-50"
                      >
                        Eliminar
                      </button>
                    </>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
